module.exports = __webpack_public_path__ + "static/media/Galeri_17.dde59883.jpg";